<script>
	import { mapGetters } from "vuex";
	import Placeholder from "./Placeholder/Total";
	export default {
		components: { Placeholder },
		computed: {
			...mapGetters(["getTotal", "isMaster"])
		}
	};
</script>

<template>
	<div>
		<div class="panel panel-default" v-if="isMaster">
			<div class="panel-body">
				Circuitos Encontrados <span class="badge">{{ getTotal }}</span> 
			</div>
		</div>
		<placeholder v-else></placeholder>
	</div>
</template>

<style scoped>
	.panel {border: 0;}
	.panel > .panel-body {padding: 15px; text-align: center; font-size: 15px;}
</style>